import { api, apiAuth } from "./Configs/AxiosConfigs"
import { defineCancelApiObject } from "./Configs/AxiosUtils"

export const CategoryAPI = {

    getCategory: async function (cancel = false) {
        const response = await api.request({
          url: "/categories/",
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          },
          signal: cancel ? cancelApiObject[this?.getCategory?.name]?.handleRequestCancellation()?.signal : undefined,
        })  
        return response.data;
      }
 
}

// defining the cancel API object for CategoryAPI
const cancelApiObject = defineCancelApiObject(CategoryAPI)